import api from "./rnplService";

export function getAllLoans(payload) {
  const params = new URLSearchParams();
  params.append("page", payload.page);
  params.append("limit", payload.limit);

  if (payload.status) {
    params.append("status", payload.status);
  }

  return api
    .get(`/loans`, { params })
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function getAllDisbursement(payload) {
  const params = new URLSearchParams();
  params.append("page", payload.page);
  params.append("limit", payload.limit);
  return api
    .get(`/loans/disbursements`, { params })
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function getLoanSummary(payload) {
  const params = new URLSearchParams();
  params.append("period", payload.period);
  return api
    .get(`/loans/summary`, { params })
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function getAllLoanAmountSummary() {
  return api
    .get(`/loans/total-summary`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function getSingleLoan(id) {
  return api
    .get(`/loans/${id}`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function getPersonalDetails(id) {
  return api
    .get(`/user/personal-details/${id}`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function getNextOfKinDetails(id) {
  return api
    .get(`/user/next-of-kin/${id}`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function getEmploymentDetails(id) {
  return api
    .get(`/user/employment-details/${id}`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function getGuarantorDetails(id) {
  return api
    .get(`/user/guarantor-details/${id}`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function getUploadedDocuments(id) {
  return api
    .get(`/user/documents/${id}`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function getUserBankStatement(id) {
  return api
    .get(`/user/bank-statement/${id}`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function getBankDetails(id) {
  return api
    .get(`/user/bank-details/${id}`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function approveLoan(payload) {
  return api
    .patch(`/loans/approve`, payload)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function rejectLoan(id, body) {
  return api
    .patch(`/loans/${id}/reject`, body)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function disburseLoan(id) {
  return api
    .patch(`/loans/disburse/${id}`, {})
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function getDashboardDataApi(value) {
  return api
    .get(`/dashboard?period=${value}`)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}

export function initiateRepayment(payload) {
  return api
    .post(`/repayments/initiate`, {
      loanId: payload.loanId,
      amount: payload.amount
    })
    .then(data => {
      return data.data
    })
    .catch(error => {
      return error.response;
    });
}

export function markLoanAsPaid(id) {
  return api
    .patch(`/loans/status/${id}`, {
      status: "repaid"
    })
    .then(data => {
      return data.data
    })
    .catch(error => {
      return error.response;
    });
}

export function markLoanRepayment(id, body) {
  return api
    .patch(`/repayments/payment-status/${id}`, body)
    .then(data => {
      return data.data;
    })
    .catch(error => {
      return error.response;
    });
}



//////////////////
// WEBPACK FOOTER
// ./services/loans.js
// module id = null
// module chunks = 